import { useTranslation } from "react-i18next";

import { Button, DropdownItem, Spacer, Typography, Skeleton } from "@aviary";
import { BrandLink } from "@emerson/components/BrandLink/BrandLink";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";
import type { BrandSplinter } from "@shared/data/queries/BrandsQuery/Brands.query";
import { EmersonSearchApplyFilterEntryPoint } from "@shared/hooks/useAnalyticsLogger/EmersonAnalyticsEntryPoint";

import * as styles from "./PopularBrands.styles";

interface Props {
  brands: BrandSplinter[];
  isLoading: boolean;
}
const PopularBrands = ({ brands, isLoading }: Props) => {
  const { t } = useTranslation();

  const renderBrandsList = () => {
    if (isLoading) {
      return Array.from({ length: 16 }).map((_, index) => {
        return <Skeleton key={index} type="typography" isFullWidth />;
      });
    }

    return brands.map(brand => {
      return (
        <DropdownItem tabIndex={-1} noStyle key={brand.id} closeOnItemSelect>
          <BrandLink
            isColor="system"
            isUnderLined={false}
            entryPoint={EmersonSearchApplyFilterEntryPoint.BRANDS_MENU}
            isHoverUnderLined
            brand={brand}
          >
            {brand.name}
          </BrandLink>
        </DropdownItem>
      );
    });
  };

  return (
    <div css={styles.PopularBrandsContainer}>
      <Typography type="h5">{t(l.header.Brands.PopularBrands)}</Typography>
      <Spacer height="half" />
      <div css={[styles.BrandsBox, isLoading && styles.FullWidth]}>
        {renderBrandsList()}
        <Button to={emersonRoutes.brands} css={styles.SeeAllButton} intention="system">
          {t(l.header.Brands.SeeAll)}
        </Button>
      </div>
    </div>
  );
};

export { PopularBrands };
